<template>
  <div>
    <confirm-modal
        v-model="modalExcluir"
        @modalAcaoCancelar="fecharModalExcluirProcedimento"
        @modalAcaoConfirmar="excluirProcedimento"
        :persistencia="false"
        mensagemInicial="Deseja realmente excluir o procedimento?"/>
    <v-dialog
        v-model="model"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Modo edição - {{ dente.nome }} ({{ dente.numero }})</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="container-detalhes">
            <div class="container-foto-dente-selecionado">
              <odontograma-dente :imagem="dente.foto" :possui-procedimentos="false"/>
            </div>
            <div>
              <div class="detalhes-procedimentos-item">
                <v-icon small class="primary--text" v-if="dente.foiExtraido">fas fa-check</v-icon>
                <v-icon small class="error--text" v-if="!dente.foiExtraido">fa fa-times</v-icon>
                <label class="ml-1">Extraído</label>
              </div>
              <div class="detalhes-procedimentos-item">
                <v-icon small class="primary--text" v-if="dente.possuiCanal">fas fa-check</v-icon>
                <v-icon small class="error--text" v-if="!dente.possuiCanal">fa fa-times</v-icon>
                <label class="ml-1">Canal</label>
              </div>
              <div class="detalhes-procedimentos-item">
                <v-icon small class="primary--text" v-if="dente.possuiRestauracao">fas fa-check</v-icon>
                <v-icon small class="error--text" v-if="!dente.possuiRestauracao">fa fa-times</v-icon>
                <label class="ml-1">Restaurado</label>
              </div>
            </div>
          </div>
          <div class="container-inserir-procedimento">
            <div class="container-faces">
              <label>Faces</label>
              <FacesDentes :faces="facesDentes" :faceSelecionada="dadosGerais.faceSelecionada"
                           @selecionarFace="selecionarFace"/>
            </div>
            <div class="container-principal-detalhes-inserir">
              <div class="container-detalhes-inserir-procedimento">
                <div>
                  <span style="font-weight: 500">Face</span><br/>
                  <label>{{
                      dadosGerais.faceSelecionada ? dadosGerais.faceSelecionada : 'Nenhuma face selecionada...'
                    }}</label>
                </div>
                <div class="mr-2">
                  <v-switch
                      v-model="dadosGerais.ehExtraido"
                      label="Foi extraído"
                      hide-details
                  />
                  <v-switch
                      v-model="dadosGerais.ehCanal"
                      label="Tem canal"
                      hide-details
                  />
                  <v-switch
                      v-model="dadosGerais.ehRestaurado"
                      label="Restaurado"
                      hide-details
                  />
                </div>
              </div>
              <v-textarea
                  v-model="dadosGerais.descricao"
                  name="descricao"
                  placeholder="Descreva o procedimento realizado..."
                  filled
                  auto-grow
                  counter="400"
                  maxlength="400"
                  full-width
                  class="container-descricao-procedimento">
                <template v-slot:label>Descrição</template>
              </v-textarea>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="atendimentoId" @click="abrirModalExcluirProcedimento" color="grey"
                 class="botao-excluir-evento mr-4" icon outlined>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn @click="fecharModal" text depressed v-if="atendimentoId">Cancelar</v-btn>
          <v-btn class="ml-5" @click="atualizarProcedimento" outlined v-if="atendimentoId">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FacesDentes from '@/views/pages/cadastros/paciente/comum/odontograma/FacesDente.vue'
import OdontogramaDente from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaDente.vue'
import {actionTypes, mutationTypes} from '@/core/constants'
import _ from 'lodash'
import ConfirmModal from '@/views/components/ConfirmModal.vue'

export default {
    name: 'ModalEditarProcedimento',
    components: {ConfirmModal, OdontogramaDente, FacesDentes},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        dente: {
            type: Object,
            required: true
        },
        atendimentoId: Number,
        procedimento: Object,
        persistencia: {
            type: Boolean,
            default: true
        },
        maxWidth: {
            type: Number,
            default: 600
        }
    },
    data() {
        return {
            modalExcluir: false,
            facesDentes: {
                lingual: 'Lingual',
                distal: 'Distal',
                oclusal: 'Oclusal',
                mesial: 'Mesial',
                vestibular: 'Vestibular'
            },
            dadosGerais: {
                faceSelecionada: null
            },
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    mounted() {
        this.setarDadosGerais()
    },
    methods: {
        setarDadosGerais() {
            let procedimento = this.procedimento
            procedimento.faceSelecionada = this.setarFaceSelecionada()
            this.dadosGerais = _.cloneDeep(procedimento)
        },
        setarFaceSelecionada() {
            if (this.procedimento.faceLingual) {
                return 'Lingual'
            }
            if (this.procedimento.faceDistal) {
                return 'Distal'
            }
            if (this.procedimento.faceOclusal) {
                return 'Oclusal'
            }
            if (this.procedimento.faceMesial) {
                return 'Mesial'
            }
            if (this.procedimento.faceVestibular) {
                return 'Vestibular'
            }
            if (this.procedimento.faceCervical) {
                return 'Cervical'
            }
        },
        selecionarFace(faceSelecionada) {
            this.dadosGerais.faceSelecionada = faceSelecionada
        },
        abrirModalExcluirProcedimento() {
            this.modalExcluir = true
        },
        fecharModalExcluirProcedimento() {
            this.modalExcluir = false
        },
        async excluirProcedimento() {
            const input = {
                atendimentoId: this.atendimentoId,
                id: this.dadosGerais.id
            }
            this.setMensagemLoading('Removendo o procedimento...')
            await this.$store.dispatch(actionTypes.ATENDIMENTO.REMOVER_PROCEDIMENTO, input)
            this.notificarAtualizacaoOdontograma()
            this.mostrarNotificacaoSucessoDefault()
        },
        async atualizarProcedimento() {
            if (this.validarDadosFormulario()) {
                const faceSelecionadaInput = this.montarAtributosFaceSelecionada()
                const input = {
                    atendimentoId: this.atendimentoId,
                    id: this.dadosGerais.id,
                    descricao: this.dadosGerais.descricao,
                    ehExtraido: this.dadosGerais.ehExtraido,
                    ehCanal: this.dadosGerais.ehCanal,
                    ehRestaurado: this.dadosGerais.ehRestaurado,
                    ...faceSelecionadaInput
                }
                this.setMensagemLoading('Atualizando o procedimento...')
                const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.ATUALIZAR_PROCEDIMENTO, input)
                if (resposta) {
                    this.notificarAtualizacaoOdontograma()
                    this.mostrarNotificacaoSucessoDefault()
                }
            }
        },
        validarDadosFormulario() {
            if (!this.dadosGerais.descricao && this.dadosGerais.faceSelecionada) {
                this.mostrarNotificacaoErro('Informe a descrição do procedimento realizado!')
                return false
            }
            if (!this.atendimentoId) {
                this.mostrarNotificacaoErro('Selecione um atendimento para editar o procedimento!')
                return false
            }
            if (!this.dadosGerais.descricao && !this.dadosGerais.faceSelecionada && !this.dadosGerais.ehExtraido && !this.dadosGerais.ehCanal && !this.dadosGerais.ehRestaurado) {
                this.mostrarNotificacaoErro('Não é possível alterar um procedimento para em branco!')
                return false
            }
            return true
        },
        montarAtributosFaceSelecionada() {

            let faces = {
                faceLingual: false,
                faceDistal: false,
                faceOclusal: false,
                faceMesial: false,
                faceVestibular: false,
                faceCervical: false
            }

            if (this.dadosGerais.faceSelecionada === 'Lingual') {
                faces.faceLingual = true
            }
            if (this.dadosGerais.faceSelecionada === 'Distal') {
                faces.faceDistal = true
            }
            if (this.dadosGerais.faceSelecionada === 'Oclusal') {
                faces.faceOclusal = true
            }
            if (this.dadosGerais.faceSelecionada === 'Mesial') {
                faces.faceMesial = true
            }
            if (this.dadosGerais.faceSelecionada === 'Vestibular') {
                faces.faceVestibular = true
            }
            if (this.dadosGerais.faceSelecionada === 'Cervical') {
                faces.faceCervical = true
            }

            return faces
        },
        fecharModal() {
            this.model = false
            this.$emit('modalDenteSelecionadoAcaoFechar')
        },
        notificarAtualizacaoOdontograma() {
            this.$store.commit(mutationTypes.ODONTOGRAMA.ATUALIZAR_ODONTOGRAMA, true)
            this.model = false
            this.$emit('procedimentoAtualizado')
        }
    }
}

</script>

<style scoped lang="stylus">

.detalhes-procedimentos-item
  display flex

.container-detalhes
  margin-top 10px
  display flex

.container-foto-dente-selecionado
  border 2px solid #b0b0b0
  border-radius 10px
  overflow clip
  margin-right 10px

.container-inserir-procedimento
  display flex
  padding 10px

.container-faces
  display flex
  flex-direction column
  align-items center
  justify-content center

.container-principal-detalhes-inserir
  margin-left 15px
  width 100%

.container-detalhes-inserir-procedimento
  margin-bottom 10px
  display flex
  justify-content space-between

</style>